import React from 'react'

import { Container } from 'components/Layout'
import Page from 'components/Page'
import PageHeader from 'components/Page/PageHeader'
import { Crumbs, Crumb } from 'components/BreadCrumbs'

import { HostedVoiceServicesList } from 'features/Services/HostedVoice/HostedVoiceServicesList'

export default props => {
  return (
    <Page layout={{ header: 'app' }} title="Hosted Voice">
      <PageHeader>
        <Crumbs title="Hosted Voice">
          {props.isProduction ? null : (
            <Crumb to="/dashboard/hosted-voice/phone-systems">Phone Systems</Crumb>
          )}
        </Crumbs>
      </PageHeader>

      <Container paddingTop paddingBottom>
        <HostedVoiceServicesList />
      </Container>
    </Page>
  )
}



// WEBPACK FOOTER //
// ./src/pages/Services/HostedVoice/HostedVoice.jsx